import { COLOR_SECONDARY_BLUE_700 } from '../../../themes/InaccessibleLight/colors.values';
export function getOutlineColor(transformer) {
    return Object.freeze({
        secondary: {
            blue700: transformer.outlineColor(COLOR_SECONDARY_BLUE_700),
        },
    });
}
